import React from 'react';
import loadable from '@loadable/component';
import runOnEnter from 'routes/helpers/runOnEnter';
import requireLoggedInSaga from 'routes/helpers/requireLoggedIn';
import requireMembershipSaga from 'routes/helpers/requireMembershipStatus';
import { memberStatus } from 'enums/memberStatus';
import { setApplePayAvailable } from 'helpers/storage';
import { checkWinbackOfferPermissionSaga } from './Rejoin.saga';

const CmsPage = loadable(() => import('containers/CmsPage/CmsPage'));

export const RejoinRoute = (store, client) => {
  const requireLoggedIn = (nextState, replaceState, cb) =>
    store
      .runSagaOnce(requireLoggedInSaga, nextState, replaceState)
      .toPromise()
      .then(cb, cb);

  const requireChurned = (nextState, replaceState, cb) =>
    store
      .runSagaOnce(requireMembershipSaga, client, replaceState, [memberStatus('CANCELLED')])
      .toPromise()
      .then(cb, cb);

  const requireEligible = (nextState, replaceState, cb) =>
    store
      .runSagaOnce(
        checkWinbackOfferPermissionSaga,
        client,
        replaceState,
        null,
        `/rejoin/welcome-back${nextState.location.search}`
      )
      .toPromise()
      .then(cb, cb);

  const checkApplePaySupport = query => {
    const applePayAvailable = !!(query.webview && query.apple_pay_available);
    setApplePayAvailable(applePayAvailable); // Since used in-app webviews, no need to expire the storage
  };

  return {
    path: 'rejoin',

    onEnter: (nextState, replaceState, cb) => {
      requireChurned(nextState, replaceState, cb);
      checkApplePaySupport(nextState.location.query);
    },

    indexRoute: {
      // only allow
      // - logged in + churned + eligible
      component: props => <CmsPage {...props} />,
      onEnter: runOnEnter(requireLoggedIn, requireEligible),
    },

    childRoutes: [
      {
        // only allow
        // - logged in + churned
        path: 'welcome-back',
        component: props => <CmsPage {...props} />,
        onEnter: runOnEnter(requireLoggedIn),
      },
      {
        // allow
        // - non-logged in
        // - logged in + churned + eligible
        path: '*',
        component: props => <CmsPage {...props} />,
        onEnter: requireEligible,
      },
    ],
  };
};
